export enum AppBrand {
    BOLT = "bolt",
    HOPP = "hopp",
}
